import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header';
import { useAuth } from '../../hooks/useAuth';
import { localStorageKeys } from '../../utils/enums';
import { getItemFromLocalStorage, storeItemToLocalStorage } from '../../utils/localStorage';
import CustomTabs from '../../components/CustomTabs';
import UsersPLITable from '../../components/tables/sales/UsersPLITable';
import MachinesPLITable from '../../components/tables/sales/MachinesPLITable';
import ToolsPLITable from '../../components/tables/sales/ToolsPLITable';
import VehiclesPLITable from '../../components/tables/sales/VehiclesPLITable';
import TrucksPLITable from '../../components/tables/sales/TrucksPLITable';
import Icon from '../../components/Icon';
import MaterialPDFModal from '../../components/modals/MaterialPDFModal';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import { usePageTitle } from '../../hooks/usePageTitle';
import IconButton from '../../components/shared/IconButton';
import PrimaryBox from '../../components/PrimaryBox';

const PLIPage: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState(parseInt(getItemFromLocalStorage(localStorageKeys.TAB.PLI) || '0'));
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { t } = useTranslation();
    const { user } = useAuth();
    usePageTitle(t('pli').toUpperCase());

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setSelectedTab(newValue);
        storeItemToLocalStorage(localStorageKeys.TAB.PLI, newValue.toString());
    };

    return (
        <PrimaryBox>
            <Header title={t('sales')} breadcrumbs={[{ label: t('pli').toUpperCase() }]} subTitle={t('pli').toUpperCase()} isDateVisible={false}>
                <IconButton
                    iconName="pictureAsPdf"
                    title={capitalizeFirstLetter(t('material'))}
                    onClick={() => setIsModalOpen(true)}
                    sx={{ color: '#B30B00' }}
                />
            </Header>
            <CustomTabs
                selectedTab={selectedTab}
                handleTabChange={handleTabChange}
                tabLabels={[t('users'), t('machines'), t('tools'), t('vehicles'), t('trucks')]}
            />
            {selectedTab == 0 && <UsersPLITable />}
            {selectedTab == 1 && <MachinesPLITable />}
            {selectedTab == 2 && <ToolsPLITable />}
            {selectedTab == 3 && <VehiclesPLITable />}
            {selectedTab == 4 && <TrucksPLITable />}
            <MaterialPDFModal open={isModalOpen} handleClose={() => setIsModalOpen(false)} />
        </PrimaryBox>
    );
};

export default PLIPage;
